
<div>
	<div class="dwform" style="padding-right: 15px; padding-left: 5px;">

        <div class="dwform-row">
            <label class="label-field">Item Prefix:</label>
            <span class="form-required">*</span>
            <input id="item_prefix" class="input-field-shortest"
                   (focusout)="checkUniqueItemPrefix()"
                   style="width:80px;"
                   [disabled]="!isEditing"
                   matTooltip="Used to identify finished forms"
                   [(ngModel)]="itemPrefix" maxlength="60"
                   placeholder="<Item Pref.>"
                   type="text" max="100" min="0">

            <button mat-button class="command-button"
                    *ngIf="isEditing"
                    (click)="doItemPrefixHint()"
                    style="scale: 90%; width: 80px;margin-left: 35px;"
                    matTooltip="get the next number"
                    matTooltipPosition="right">Hint</button>
        </div>

		<div class="dwform-cell-nopadding" style="min-width: 510px;">
			<div class="dwform-row-double-gap"></div>
			<div class="dwform-row">
				<label class="label-field" style="vertical-align: top;">Description:</label> <span
					class="form-required">*</span>
				<textarea id="description"
					class="text-area-input text-area-override" [disabled]="!isEditing"
					[(ngModel)]="description" placeholder="<Description>" type="text">
                                    </textarea>
			</div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row">
				<label class="label-field">Threshold Level:</label> <span
					class="form-required">*</span> <input id="inv_warning_threshold"
					class="input-field-shortest" style="width: 70px;"
					[disabled]="!isEditing"
					matTooltip="Show a warning when inventory reaches this level"
					[(ngModel)]="invWarningThreshold" maxlength="60"
					placeholder="<Number>" type="number" max="100" min="0"><span>%</span>
			</div>
			<div class="dwform-row-gap"></div>

			<div class="dwform-row">
				<label class="label-field">Grace Days:</label> <span
					class="form-required">*</span> <input id="expiration_grace_days"
					class="input-field-shortest" style="width: 70px;"
					matTooltip="Disallow medication when this number of days from the expiration date is reached"
					[disabled]="!isEditing" [(ngModel)]="expirationGraceDays"
					maxlength="60" placeholder="<Number>" type="number" max="100"
					min="0">
			</div>
			<div class="dwform-row-gap"></div>

			<div class="dwform-row-gap"></div>
		</div>
		<div class="dwform-row">
			<label class="label-field">Schedule:</label> <span
				class="form-required">*</span> <input id="schedule"
				class="input-field-shortest" style="width: 70px;"
				matTooltip="Indicates the drug's classification according to regulatory guidelines"
				[disabled]="!isEditing" [(ngModel)]="schedule" maxlength="60"
				placeholder="<0-5>" type="number" max="5" min="0">
		</div>
		<div class="dwform-row-gap"></div>
	</div>
	<!----------------------->
	<!-- ERROR LINE --------->
	<!----------------------->
	<div class="error-line" [hidden]='!strErr.length'
		style="text-align: left; bottom: 45px; margin-left: 5px">{{strErr}}</div>
	<!----------------------->
	<!-- SAVE STRIP        -->
	<!----------------------->
	<div class="save-close-strip" style="bottom: 10px;">

		<button mat-button class="command-button" *ngIf="this.isEditing"
			(click)="submitRecord()" matTooltip="Submit the selected record"
			mat-button>
			<mat-icon>check_circle_outline</mat-icon>
			Submit
		</button>
		<button mat-button class="command-button" *ngIf="this.isEditing"
			(click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
			<mat-icon>highlight_off</mat-icon>
			Cancel
		</button>
	</div>
</div>
